export enum LoadingType {
  Default,
  Gradient,
  Black,
  WhiteBox,
}
